// components/Layout.js
import '../styles/Layout.css';
import '../styles/common.css';
import Sidebar from './Sidebar';
import { Outlet, useNavigate } from 'react-router-dom';
import { logout, isLoggedIn, getUserRole, getCompanyName, getUserName, getDailyReportUrl } from './Auth';
import { useEffect, useState } from 'react';

const Layout = () => {
  const [loggedIn, setLoggedIn] = useState(isLoggedIn());
  const [userRole, setUserRole] = useState(getUserRole());
  const [companyName, setCompanyName] = useState(getCompanyName());
  const [userName, setUserName] = useState(getUserName());
  const [dailyReportUrl, setDailyReportUrl] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    // ローカルストレージ変更検知（storageイベントは別タブ対策用）
    const handleStorageChange = () => {
      setLoggedIn(isLoggedIn());
      setUserRole(getUserRole());
      setCompanyName(getCompanyName());
      setUserName(getUserName());
      setDailyReportUrl(getDailyReportUrl());
    };

    handleStorageChange(); // 初期化用
    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  const handleLogout = async () => {
    await logout();  // sessionStorageクリアなど
    navigate('/login');  // Reactルーターで遷移
  };

  return (
    <div className="layout-container">
      <header className="header">
        <span>
          株式会社妙香｜AIスキルカリキュラム
          {loggedIn && companyName && `（${companyName} - ${userName}）`}
        </span>
        {loggedIn && (
          <div className="header-actions">
            {dailyReportUrl && (
              <a
                href={dailyReportUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="daily-report-button"
              >
                日報記載
              </a>
            )}
            <button className="logout-button" onClick={handleLogout}>ログアウト</button>
          </div>
        )}
      </header>
      <div className="content-body">
        <main className="main-content">
          <Outlet context={{ userRole }} />
        </main>
        {loggedIn && <Sidebar role={userRole} />}
      </div>
      <footer className="footer">&copy; 2025 株式会社妙香 All rights reserved.</footer>
    </div>
  );
};

export default Layout;
